











































































import Vue from "vue";

const helper = (arr: any, select) => {
  return arr.map((item: any) => {
    const res: any = {
      title: item.data.deptName,
      value: item.id,
      key: item.id,
      disabled: item.id === select.id
    };
    if (item.children && item.children.length > 0 && item.id !== select.id)
      res.children = helper(item.children, select);
    return res;
  });
};

export default Vue.extend({
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    itemList: {
      type: Array,
      default: () => []
    }
  },
  beforeDestroy() {
    console.log("destory");
  },
  data() {
    return {
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    };
  },
  computed: {
    treeData() {
      console.log(this.itemList, this.item);
      const list = helper(this.itemList, this.item);
      return list;
    }
  },
  watch: {
    item(newVal) {
      this.form.setFieldsValue({
        deptName: newVal.deptName,
        sort: newVal.sort,
        parentId: newVal.parentId,
        remark: newVal.remark,
        isEnable:newVal.isEnable
      });
    }
  }
});
